import React, { useEffect } from "react";
import { brandPalette } from "../../../../constants/brandPalette";
import {
  Box,
  Button,
  Flex,
  Heading,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { closeCreateAssistant } from "../../../../modules/admin-modules/models/Actions";
import MainModel from "../../../../components/Models/main-model";
import {
  adminModalBodyProps,
  adminModalContentProps,
  adminModalHeaderProps,
} from "../../../../components/Models/admin-modal-theme";
import { useForm } from "react-hook-form";
import MainInput from "../../../../components/Form/input";
import {
  createAssistantRequest,
  editAssistantRequest,
} from "../../../../modules/admin-modules/assistants/Actions";
import { openShowAssistantDataModel } from "../../../../modules/admin-modules/models/Actions";

const AddAssistant = ({
  isAdd,
  data,
  setSelectedData,
  setCreatedAssistantData,
}) => {
  const openAssistant = useSelector((state) => state.model.isOpen41);
  const isLoading = useSelector((state) => state.assistants.isLoading);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: data ? data : {},
    shouldUnregister: true,
  });

  useEffect(() => {
    if (data && !isAdd) {
      reset({
        name: data.name || "",
        phone: data.phone || "",
      });
    } else {
      reset({
        name: "",
        phone: "",
      });
    }
  }, [data, isAdd, reset]);

  const header = (
    <Box>
      <Heading
        fontSize="32px"
        fontWeight="800"
        color={brandPalette.primary}
        fontFamily="'Amiri','Tajawal',sans-serif"
      >
        {isAdd ? "Add Teaching Assistant" : "Edit Teaching Assistant"}
      </Heading>
      <Text
        fontSize="xs"
        mt={1}
        color="var(--text-muted)"
        textTransform="uppercase"
        letterSpacing="0.14em"
        fontWeight="700"
      >
        Name and contact phone for the assistant
      </Text>
    </Box>
  );

  const onSubmit = async (formData) => {
    if (!formData.name || !formData.phone) {
      return;
    }

    const action = (createdData) => {
      dispatch(closeCreateAssistant());
      setSelectedData({});
      reset();
      if (isAdd && createdData && setCreatedAssistantData) {
        setCreatedAssistantData(createdData);
        dispatch(openShowAssistantDataModel());
      }
    };

    if (isAdd) {
      await dispatch(createAssistantRequest(formData, action));
    } else {
      const result = await dispatch(
        editAssistantRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
      if (result && result.type && result.type.includes("SUCCESS")) {
        action();
      }
    }
  };

  const closeFunc = () => {
    dispatch(closeCreateAssistant());
    setSelectedData({});
    reset();
  };

  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openAssistant}
      buttonTitle={null}
      buttonFunc={handleSubmit(onSubmit)}
      size="2xl"
      contentProps={adminModalContentProps}
      headerProps={adminModalHeaderProps}
      bodyProps={adminModalBodyProps}
      hideDefaultFooter
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={6} dir="ltr" w="100%">
          <MainInput
            label="Name"
            error={errors?.name?.message}
            placeholder="Full name"
            register={register}
            name="name"
            required
          />
          <MainInput
            label="Phone"
            error={errors?.phone?.message}
            placeholder="+00 000 000 0000"
            register={register}
            name="phone"
            required
          />
          <Flex justify="flex-end" gap={6} pt={4}>
            <Button
              variant="ghost"
              color="var(--text-primary)"
              fontWeight="800"
              _hover={{ textDecoration: "underline", bg: "rgba(91, 13, 22, 0.08)" }}
              onClick={closeFunc}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              bg={brandPalette.primary}
              color="white"
              borderRadius="lg"
              px={8}
              py={6}
              fontWeight="800"
              isLoading={isLoading}
              _hover={{ bg: brandPalette.accentDark }}
              boxShadow="0 10px 24px rgba(91, 13, 22, 0.18)"
            >
              Save Changes
            </Button>
          </Flex>
        </Stack>
      </form>
    </MainModel>
  );
};

export default AddAssistant;
